export {
  FreeSearchFormCalendar,
  CalendarContainer,
  CalendarWeekdays,
  MainTabBar,
  PassengersDataForm,
  FlightDetailsCarousel,
  getCityImgSrc,
  FlightDetailsBottomSheet,
  ErrorScreen,
  ErrorBlock,
  ConfirmationModal,
  SearchDirectionInputs,
  SearchFormInput,
  CitySelectBottomSheet,
  SavedPassengersBottomSheet,
  PublicOfferBottomSheet,
  RwPassengerDataForm,
  CashbackInfoBottomSheet,
  CashbackPromoBottomSheet,
  useCashbackPromoVisibility,
  SearchDateRangeInputs,
  RoamingDevicesBottomSheet,
  RoamingSelectBrandButton,
  RoamingSelectBrandBottomSheet,
  BaseRoamingConfig,
  BaseMedicalInsuranceConfig,
  NoSavedPassengers,
  CSDelayModal,
  useCSDelayModal,
  MainPageHeader,
  TabBarButton,
} from './widgets';

/**
 * Lazy async-component factories.
 *
 * Used by consumer apps with `defineAsyncComponent` / `defineLazyComponent` so
 * the bottom-sheet chunks are loaded only when a user opens them — they stay
 * out of the eager app-shared chunk.
 *
 * Import them from this public barrel (`import { ... } from 'freedom-shared'`)
 * — do NOT reach into `freedom-shared/src/widgets/...` directly, because
 * those paths bypass the public API and will break when an `exports` map is
 * added to the package.
 */
export const CashbackInfoBottomSheetAsync = () =>
  import('./widgets/cashback-info-bottom-sheet/ui/CashbackInfoBottomSheet.vue');

export const CashbackPromoBottomSheetAsync = () =>
  import(
    './widgets/cashback-promo-bottom-sheet/ui/CashbackPromoBottomSheet.vue'
  );

export { default as TrainIcon } from './assets/images/train.svg?component';

export {
  freedomAuth,
  freedomAuthDefaultAuthData,
  freedomAuthMockDataStorageKey,
  freedomPayment,
  CashbackHeaderButton,
  FreedomCashbackLabel,
  freedomCashbackModel,
  useFreedomCashbackQuery,
  useFreedomCashback,
  type FreedomCashbackModel,
  AppSwitchButton,
  rwPassengerDataValidation,
  rwPassengerDataValidationTypes,
  OneWayNearestSearches,
  type MappedNearestSearch,
  withSuperAppDeeplink,
  cacheConfig,
  ProductListErrorCard,
} from './features';

export {
  AppError,
  freedomApp,
  AirlineIconsGroup,
  FaqBottomSheet,
  faq,
  FlightDetailsCard,
  flightEntity,
  CitizenshipBottomSheet,
  FullScreenLoader,
  ErrorModal,
  userStoreEntity,
  accessTokenMemoryStorage,
  tokenStorage,
  PassengerInfoButton,
  SelectPassengerButton,
  PassengerCard,
  bookingPassengerEntity,
  countdownTimer,
  CountdownTimer,
  PaymentErrorModal,
  ExpiredPaymentModal,
  PaidPaymentErrorModal,
  DefaultPaymentErrorModal,
  rwPassengersData,
  rwPassengersDataTypes,
  SupportedMiniApps,
  type freedomAppTypes,
  FreeLabel,
  amplitudeExperiment,
  EmptyResults,
  CharterFlightInfoContainer,
  CharterLabel,
  CharterFlightDescriptionBottomSheet,
  CharterFlightNonRefundableBottomSheet,
  useCharterFlightBottomSheet,
  parseIin,
  type ParsedIin,
  StationSquarePreview,
  MilesCardFormBottomSheet,
  MilesProgramListBottomSheet,
  MilesCardDeleteAlert,
  MilesCardProgramNotice,
  milesCardLib,
  type AirlineLoyaltyCard,
  type AirlineLoyaltyProgram,
  type MilesCardValueValidation,
  type MilesProgramView,
} from './entities';

export {
  FreeButton,
  FreeCounter,
  FreePageLayout,
  FreeCloseButton,
  FreeCheckbox,
  FreeBottomSheet,
  FreeHeader,
  FreeSegmentControl,
  FreeSegment,
  FreeAlert,
  FreeSearchInput,
  FreeInput,
  FreeTextarea,
  FreeLoader,
  FreeModal,
  FreeSwitch,
  FreeRadio,
  FreeSlider,
  FreeBackButton,
  FreeCarouselLegacy,
  FreeBulletsLegacy,
  FreeCarouselItemLegacy,
  FreeCarousel,
  FreeCarouselItem,
  FreeCarouselDynamicBullets,
  FreeRadioBlock,
  FreeFormInput,
  AirlineIcon,
  CopyButton,
  AirlineIconSizeEnum,
  type Airline,
  FreeImage,
  WithAccordionFadeTransition,
  FreeAlertWithUseAlert,
  BottomNav,
  type BottomNavItemConfig,
} from './shared/ui';

export {
  appNavLinks,
  useMiniAppNavigation,
  resetStore,
  poll,
  vueQueryLib,
  amplitudeLib,
  googleAnalyticsLib,
  CfTurnstileChallenge,
  utmTagsLib,
  handleSplashScreen,
  debug,
  withAmplitudeDeviceId,
  generateRandomPastelColor,
  getSeatMapUniqPrices,
  type SeatMapForUtils,
  useHorizontalScrollToActive,
  useFavoriteAnimation,
  PARTICLES_ORIGIN_LEFT,
  PARTICLES_ORIGIN_TOP,
  PARTICLES_TRANSFORM,
  TICKETON_MINIAPP_BASE_URL,
  normalizeTicketonMiniAppUrl,
  focusAndOpenKeyboard,
} from './shared/lib';

export {
  useSavedScrollPosition,
  useFirebaseStore,
  withFirebase,
  setStatusBarHeight,
  getStatusBarHeight,
  withTheme,
  usePopStateHandler,
  handleChunkLoadError,
  type HandleChunkLoadErrorOptions,
} from './shared/model';

export {
  FlowType,
  App,
  aviaMasksOptions,
  railwaysMasksOptions,
} from './shared/config';
